/// <amd-module name="Release/Helpers/BuildReleaseDefinitionProvider" />

import { ReleaseDefinition } from "Release/Client/Contracts/Release";
import { Services, VssService, IVssService, IVssReadConsistencyLevel, IVssPageContext } from "VSS/Platform/Context";
import { IVssContributionService } from "VSS/Platform/Contribution";
import { IReleaseRestClient } from "Release/Client/RestClient/Release";

export interface IBuildReleaseDefinitionProvider extends IVssService {
    getReleaseDefinitionsByBuild(projectId: string, buildId: number): Promise<ReleaseDefinition[]>
}

class BuildReleaseDefinitionProvider extends VssService implements IBuildReleaseDefinitionProvider {

    private _contributionService: IVssContributionService;

    public _serviceStart(pageContext: IVssPageContext): void {
        super._serviceStart(pageContext);
        this._contributionService = pageContext.getService<IVssContributionService>("IVssContributionService");
    }

    public async getReleaseDefinitionsByBuild(projectId: string, buildId: number): Promise<ReleaseDefinition[]> {

        await this._contributionService.getContributionAsync("ms.vss-releaseManagement-web.release-service-location");
        const releaseClientOptions = { readConsistencyLevel: IVssReadConsistencyLevel.Eventual };
        const releaseClient = this.pageContext.getRestClient<IReleaseRestClient>("IReleaseRestClient", releaseClientOptions);

        return await releaseClient.getReleaseDefinitions(
            projectId,
            undefined /* searchtext */,
            undefined /* expand */,
            "Build" /* artifact type */,
            `${projectId}:${buildId}` /* artifactsourceId */,
            1 /* top */);
    }
}

Services.add("IBuildReleaseDefinitionProvider", { serviceFactory: BuildReleaseDefinitionProvider });